var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Button } from '@trustpilot/businessapp-patternlibrary';
import { Input } from '../CommonUI/Controls';
import { Auth } from '../Auth';
import { Box, Flex } from '../CommonUI/Layout';
import { LocalizationProvider, Text } from 'ilenia';
import { css, StyleSheet } from 'aphrodite';
import translations from '../localization/en-US/string.json';
import * as commonStyles from '../Styles/common';
import * as flat from 'flat';
import '../Styles/login.css';
import firebase from '../Firebase/firebase';
var LoginMFA = (function (_super) {
    __extends(LoginMFA, _super);
    function LoginMFA(props) {
        var _this = _super.call(this, props) || this;
        _this.withButtonTracking = function (track, func) {
            return function (event) {
                if (_this.props.trackButton) {
                    _this.props.trackButton(track);
                }
                if (func) {
                    func(event);
                }
            };
        };
        _this.state = { verificationCode: '', verificationCodeValid: true, recaptchaToken: '', sessionInfo: '', error: '', inProgress: false };
        _this.onSubmitVerificationCode = _this.onSubmitVerificationCode.bind(_this);
        _this.withButtonTracking = _this.withButtonTracking.bind(_this);
        _this.onRecaptchaTokenResolved = _this.onRecaptchaTokenResolved.bind(_this);
        return _this;
    }
    LoginMFA.prototype.componentDidMount = function () {
        firebase.initializeFirebaseApp(this.props.firebaseOptions);
        firebase.initializeRecaptchaVerifier('recaptcha-container');
        firebase.verifyRecaptcha().then(this.onRecaptchaTokenResolved);
    };
    LoginMFA.prototype.onRecaptchaTokenResolved = function (recaptchaToken) {
        var _this = this;
        var _a = this.props, mfaPendingCredential = _a.mfaPendingCredential, mfaEnrollmentId = _a.mfaEnrollmentId, authenticationApiUrl = _a.authenticationApiUrl;
        this.setState({ recaptchaToken: recaptchaToken });
        Auth.startMfa(mfaPendingCredential, mfaEnrollmentId, recaptchaToken, authenticationApiUrl).then(function (_a) {
            var error = _a.error, sessionInfo = _a.sessionInfo;
            _this.setState({ error: error, sessionInfo: sessionInfo });
        });
    };
    LoginMFA.prototype.onSubmitVerificationCode = function (e) {
        var _this = this;
        e.preventDefault();
        this.setState({ error: '', inProgress: true });
        var _a = this.state, verificationCode = _a.verificationCode, sessionInfo = _a.sessionInfo;
        var _b = this.props, cookiesDomain = _b.cookiesDomain, authenticationApiUrl = _b.authenticationApiUrl, mfaPendingCredential = _b.mfaPendingCredential;
        Auth.finalizeMfa(mfaPendingCredential, sessionInfo, verificationCode, cookiesDomain, authenticationApiUrl).then(function (_a) {
            var error = _a.error, loggedIn = _a.loggedIn;
            _this.setState({ error: error });
            if (_this.props.onLoggedIn) {
                _this.props.onLoggedIn(loggedIn);
            }
            if (error) {
                _this.setState({ inProgress: false });
            }
        });
    };
    LoginMFA.prototype.render = function () {
        var _this = this;
        var _a = this.state, verificationCode = _a.verificationCode, sessionInfo = _a.sessionInfo, error = _a.error, inProgress = _a.inProgress;
        var _b = this.props, source = _b.source, locale = _b.locale, phoneNumber = _b.phoneNumber;
        return (React.createElement(React.Fragment, null,
            React.createElement(Box, { pt: '16px', className: "trustpilot_form" },
                React.createElement(LocalizationProvider, { locale: locale, translations: flat.flatten(translations) },
                    React.createElement(Box, { className: css(styles.layout) },
                        React.createElement("form", { onSubmit: this.onSubmitVerificationCode },
                            React.createElement(Flex, null,
                                React.createElement("h1", null,
                                    React.createElement(Text, { id: "login.title" })),
                                React.createElement(Box, { className: css(styles.trustpilotInput) },
                                    React.createElement(Text, { id: "login.verificationCodeExplanation", interpolations: { PHONENUMBER: phoneNumber } }),
                                    React.createElement(Box, { pb: '14px' },
                                        React.createElement(Input, { id: "email", label: React.createElement(Text, { id: "login.verificationCodeLabel" }), onChange: function (evt) { return _this.setState({ verificationCode: evt.target.value }); }, value: this.state.verificationCode, errorMessage: error ? React.createElement(Text, { id: "loginMFA.error." + error }) : null, disabled: !sessionInfo || inProgress, maxLength: 6 })),
                                    React.createElement(Box, { pb: '12px' },
                                        React.createElement(Button, { id: "login", onClick: this.withButtonTracking({
                                                placement: 'Bottom left corner',
                                                action: 'Login to business app',
                                                name: 'login-mfa-to-business-app-button',
                                                source: source,
                                            }, this.onSubmitVerificationCode), disabled: !sessionInfo || verificationCode.length !== 6 || inProgress, className: css(styles.button) },
                                            React.createElement(Text, { id: "login.button" }))))))))),
            React.createElement("div", { id: "recaptcha-container" })));
    };
    return LoginMFA;
}(React.Component));
export { LoginMFA };
var styles = StyleSheet.create({
    layout: {
        fontFamily: '\'TrustpilotDefaultFont\', Arial, sans-serif',
    },
    link: {
        display: 'block'
    },
    button: __assign({ width: '100%' }, commonStyles.button),
    navLink: {
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'left',
        textDecoration: 'none',
        border: '2px solid transparent',
        borderRadius: '2px',
        outline: 'none',
        color: '#368CD7'
    },
    trustpilotInput: {
        width: '400px'
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/ecommscript-integrationappauth/dist/Forms/LoginMFA.js
// module id = 1356
// module chunks = 0